import React from "react";
import { Button } from "../../../components/ui/button";
import { Link } from "react-router-dom";

const TrialistTermsOfService = () => {
  return (
    <div className='min-h-screen bg-black text-white p-8'>
      <div className='max-w-3xl mx-auto'>
        <h1 className='text-4xl font-bold mb-8'>Trialist Terms of Service</h1>

        <div className='space-y-6'>
          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              1. Acceptance of Terms
            </h2>
            <p className='text-gray-300'>
              By accessing and using Trialist, you agree to be bound by these
              Terms of Service. Trialist is a research study application that
              facilitates participation in scientific research studies.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              2. Eligibility
            </h2>
            <p className='text-gray-300'>
              You must be at least 18 years old to use Trialist. Specific
              studies may have additional eligibility requirements. You agree to
              provide accurate information about yourself when registering and
              participating in studies.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              3. Research Participation
            </h2>
            <p className='text-gray-300'>
              Participation in research studies through Trialist is voluntary.
              Each study will have its own informed consent process. You may
              withdraw from any study at any time without penalty or loss of
              benefits to which you are otherwise entitled.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              4. User Responsibilities
            </h2>
            <p className='text-gray-300'>
              You agree to provide honest and accurate responses in all study
              activities. You are responsible for maintaining the
              confidentiality of your account credentials. You agree not to
              share study materials or participate in studies for which you are
              not eligible.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>
              5. Disclaimer
            </h2>
            <p className='text-gray-300'>
              Trialist is a research platform and does not provide medical
              advice, diagnosis, or treatment. Information provided through
              studies is for research purposes only. Always consult qualified
              healthcare providers for medical concerns.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold mb-4'>6. Contact</h2>
            <p className='text-gray-300'>
              For any questions regarding these Terms of Service, please contact
              us at: terms@anyonelabs.com
            </p>
          </section>
        </div>

        <div className='mt-8'>
          <Link to='/'>
            <Button variant='outline' className='text-green-500 border-green-500'>
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TrialistTermsOfService;
